// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"848af1fc","122":"2c62156a","187":"e15d4dd0","208":"05604dcc","453":"830799c9","483":"7df3812d","513":"36796045","556":"65be7374","827":"96d290f0","838":"76c0af3b","875":"75365b97"}[chunkId] + ".chunk.js";
};